// Copyright 1999-2022. Plesk International GmbH. All rights reserved.

import store from "@/store";

const guardGestionCasos = async (to, from, next) => {
  if (
    localStorage.getItem("user") ||
    localStorage.getItem("cliente") ||
    localStorage.getItem("id")
  ) {
    next();
  } else {
    next(`/login`);
  }
};

const autenticadoGuard = async (to, from, next) => {
  console.log(to);
  if (store.getters.user && store.getters.logged) {
    next();
  } else {
    next("/login");
  }
};

export { autenticadoGuard, guardGestionCasos };
